import { Injectable, inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "src/app/services/configuration.service";
import { IMail } from "../common/IMail.interface"

@Injectable({
  providedIn: 'root'
})
export class MailService {
  private httpClient = inject(HttpClient);
  private configService = inject(ConfigurationService);

   // Dead endpoint: backend MailController does not exist. Reevaluate later.
   public sendMail(mail: IMail) {
    return this.httpClient.post(this.configService.mailUrl, mail);
  }
}
